const features = [
  {
    icon: 'ri-4k-fill',
    title: '1080P 高清画质',
    desc: '全站综艺节目均支持超清画质播放，细节清晰，色彩饱满，给你影院级观影享受。',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '智能极速加载',
    desc: '全球部署CDN加速节点，智能预加载技术，打开即播，告别卡顿和缓冲等待。',
  },
  {
    icon: 'ri-vip-diamond-fill',
    title: '完全免费观看',
    desc: '所有综艺节目免费在线观看，无需注册登录，无需充值会员，纯粹享受娱乐。',
  },
  {
    icon: 'ri-stack-fill',
    title: '海量综艺大全',
    desc: '覆盖音乐、户外、脱口秀、选秀、美食、旅行等全品类综艺，持续扩充片库。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            为什么选择极速影院
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            四大核心优势，重新定义在线综艺观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-6 text-center transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 font-heading mb-2">
                {feature.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}